import PropTypes from 'prop-types';
import React from 'react';
import { FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import { FIELD_AUTOCOMPLETE } from '../constants/formValidation';

export default function ValidatedFormField({
  id,
  name,
  label,
  type,
  required,
  error,
  hint,
  register,
  registerOptions,
  inputMode,
  maxLength,
  autocomplete,
}) {
  const errorId = `${id}-error`;
  const hintId = `${id}-hint`;
  const describedBy = [hint && hintId, error && errorId].filter(Boolean).join(' ') || undefined;
  const { ref, ...field } = register(name, registerOptions);
  const autocompleteValue = autocomplete ?? FIELD_AUTOCOMPLETE[name];

  return (
    <FormGroup>
      <Label for={id}>
        {label}
        {required ? <span aria-label="required"> *</span> : null}
      </Label>
      {hint ? (
        <div className="validated-form-field__hint" id={hintId}>
          {hint}
        </div>
      ) : null}
      <Input
        {...field}
        innerRef={ref}
        id={id}
        type={type}
        inputMode={inputMode}
        maxLength={maxLength}
        autoComplete={autocompleteValue}
        invalid={!!error}
        aria-required={required || undefined}
        aria-describedby={describedBy}
      />
      {error ? (
        <FormFeedback id={errorId} role="alert">
          {error.message}
        </FormFeedback>
      ) : null}
    </FormGroup>
  );
}

ValidatedFormField.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  hint: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  registerOptions: PropTypes.object,
  required: PropTypes.bool,
  type: PropTypes.string.isRequired,
  inputMode: PropTypes.string,
  maxLength: PropTypes.number,
  autocomplete: PropTypes.string,
};
